export const styles = {
  button: {
    margin: 1,
    bgcolor: "primary.light",
    color: "secondary.dark",
    "&:hover": {
      bgcolor: "primary.main",
    },
  },
};
